import React from 'react';
const DataDeletion = () => {
    return (
        <div className='page'>
            <h1>Eliminación de datos</h1>
            <p>Última actualización: <strong>2025-09-08</strong></p>

            <div class="box">
                <p>Si quieres que eliminemos los datos asociados a tu interacción con <strong>Forallia BOT Definitivo</strong>, puedes solicitarlo de las siguientes formas:</p>
            </div>

            <h2>1- Solicitud por correo</h2>
            <p>Escribe a <a href="mailto:naruxforall@gmail.com">naruxforall@gmail.com</a> con el asunto <strong>“Eliminación de datos — Forallia BOT Definitivo”</strong> indicando:</p>
            <ul>
                <li>Tu nombre de usuario de Instagram.</li>
                <li>El identificador del mensaje o conversación si lo conoces.</li>
                <li>Un método de verificación de identidad (por ejemplo, escribirnos desde la misma cuenta de Instagram).</li>
            </ul>

            <h2>2- Eliminación automática (si está disponible)</h2>
            <p>Si habilitamos comandos de eliminación dentro de los mensajes (por ejemplo, enviando “BORRAR DATOS”), borraremos los datos operativos y te confirmaremos la acción. Si esta opción no está disponible, utiliza el canal por correo.</p>

            <h2>Plazos</h2>
            <p>Atenderemos tu solicitud en un plazo máximo de 30 días naturales, salvo obligaciones legales que requieran conservar cierta información.</p>

            <footer>
                © 2025 Forallia — <a href="https://forallia.com/privacy">Política de Privacidad</a>
            </footer>
        </div>
    );
};

export default DataDeletion;